import type { z } from 'zod';

import type { LegacyExamSchema } from './schemas';

type LegacyExamField = keyof z.infer<typeof LegacyExamSchema>;

const searchAttributes = ['subject', 'label'] as const satisfies readonly LegacyExamField[];
const listAttributes = [
  'id',
  'subject',
  'code',
  'label',
  'shortLabel',
  'maxMark',
  'analytics',
  'type',
  'examTypeId',
  'active',
] as const satisfies readonly LegacyExamField[];
const getAttributes = [
  ...listAttributes,
  'creationDatetime',
  'editDatetime',
  'topics',
  'printCode',
] as const satisfies readonly LegacyExamField[];
const updateAttributes = [
  'label',
  'shortLabel',
  'type',
  'editDatetime',
  'active',
  'maxMark',
] as const satisfies readonly LegacyExamField[];

export const LegacyExamAttributes = {
  Search: searchAttributes,
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
